import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-log',
  templateUrl: './event-log.component.html',
  styleUrls: ['./event-log.component.scss'],
})
export class EventLogComponent implements OnInit {
  public readonly name = 'eventlog';
  constructor() {}

  ngOnInit(): void {}
}
